import _ from 'lodash'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { BeckyPropsInitialStoreSym, ComponentsStylesOverridesSymbol, IComponentsStylesOverrides, IPropsStore, Props, PropsMap } from '@wix/thunderbolt-symbols'
import { PlatformResetComps } from '../types'

export const platformResetComps = withDependencies(
	[Props, ComponentsStylesOverridesSymbol, BeckyPropsInitialStoreSym],
	(propsStore: IPropsStore, componentsStylesOverrides: IComponentsStylesOverrides, beckyPropsInitialStore: IPropsStore): PlatformResetComps => {
		const platformPropsOverrides: Record<string, Array<string>> = {}
		const platformStyleOverrides: Record<string, Array<string>> = {}
		return {
			resetComps(compsIdsToReset) {
				if (_.isEmpty(platformPropsOverrides) && _.isEmpty(platformStyleOverrides)) {
					return
				}
				const propsToUpdate: PropsMap = {}
				const stylesToUpdate: PropsMap = {}

				if (!compsIdsToReset.length) {
					compsIdsToReset = Object.keys({ ...platformPropsOverrides, ...platformStyleOverrides })
				}

				for (const compId of compsIdsToReset) {
					// get the comp props keys which the platform overrides
					const compPropsOverrides = platformPropsOverrides[compId]
					if (compPropsOverrides && compPropsOverrides.length > 0) {
						// get the comp props that override by platform
						const overridesInitialValues = _.pick(beckyPropsInitialStore.get(compId), compPropsOverrides)
						// get the comp props that wasn't override by platform
						const propsWithoutOverrides = _.omit(propsStore.get(compId), compPropsOverrides)
						propsToUpdate[compId] = { ...propsWithoutOverrides, ...overridesInitialValues }
					}
					// get the comp styles keys which the platform overrides
					const compStylesOverrides = platformStyleOverrides[compId]
					if (compStylesOverrides && compStylesOverrides.length > 0) {
						// get the comp styles that wasn't override by platform
						stylesToUpdate[compId] = _.omit(componentsStylesOverrides.getCompStyle(compId), compStylesOverrides)
					}
				}
				if (!_.isEmpty(propsToUpdate)) {
					propsStore.set(propsToUpdate)
				}
				if (!_.isEmpty(stylesToUpdate)) {
					componentsStylesOverrides.set(stylesToUpdate)
				}
			},
			setPropsToOverride(props: PropsMap) {
				_.forEach(props, (compProps, compId) => {
					platformPropsOverrides[compId] = Object.keys(compProps)
				})
			},
			setStylesToOverride(styles: PropsMap) {
				_.forEach(styles, (compProps, compId) => {
					platformStyleOverrides[compId] = Object.keys(compProps)
				})
			},
		}
	}
)
